import React from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";
import { Form, Formik } from "formik";
import FormikInputIcon from "components/form/formik-input-icon";
import Image from "components/image";

export default function ManageUserDialog({
    userData,
    handleUserSubmit,
    showManageUserDialog,
    setShowManageUserDialog,
    validationSchemaUser,
    handleDeleteProfilePic,
    profilePicUploadHandler,
    inputLogoFileRef,
    timestamp,
    imageUrl,
    UploadPicture,
    setProfilePicDeletable,
    handleLogoUploadClick,
    profilePicDeletable,
}) {
    const handleClose = () => {
        setShowManageUserDialog((showManageUserDialog) => !showManageUserDialog);
    };

    return (
        <Dialog
            open={showManageUserDialog}
            handler={handleClose}
            className="dialog"
        >
            <DialogHeader className="dialog__header">Manage User</DialogHeader>
            <>
                <Formik
                    onSubmit={handleUserSubmit}
                    validationSchema={validationSchemaUser}
                    enableReinitialize
                    initialValues={{
                        name: userData?.name || "",
                        alt_email: userData?.alt_email || "",
                        phone: userData?.phone || "",
                        address_1: userData?.address_1 || "",
                        address_2: userData?.address_2 || "",
                        postcode: userData?.postcode || "",
                        country: userData?.country || "",
                        job_role: userData?.job_role || "",
                    }}
                >
                    {({ isValid, dirty }) => (
                        <Form>
                            <DialogBody className="dialog__body ">
                                <div>
                                    <div
                                        className="md:flex md:flex-col md:items-center
                                                rounded-2xl p-4 mb-4"
                                    >
                                        <div className="">
                                            <Image
                                                alt="Profile picture"
                                                key={timestamp}
                                                src={imageUrl}
                                                className="rounded-xl"
                                                onError={({
                                                    currentTarget,
                                                }) => {
                                                    currentTarget.onerror =
                                                        null; // prevents looping
                                                    currentTarget.src = `${UploadPicture}`;
                                                    setProfilePicDeletable(
                                                        false,
                                                    );
                                                }}
                                            />
                                        </div>
                                        <div className="p-2">
                                            <Button
                                                variant="filled"
                                                type="button"
                                                onClick={() =>
                                                    handleLogoUploadClick()
                                                }
                                                className="btn btn--secondary"
                                            >
                                                Upload Profile Image
                                            </Button>
                                            {!!profilePicDeletable && (
                                                <Button
                                                    variant="filled"
                                                    type="button"
                                                    onClick={() =>
                                                        handleDeleteProfilePic()
                                                    }
                                                    className="btn btn--danger"
                                                    size="lg"
                                                >
                                                    Delete Profile Image
                                                </Button>
                                            )}
                                            <input
                                                onChange={
                                                    profilePicUploadHandler
                                                }
                                                ref={inputLogoFileRef}
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="name"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Display Name"
                                        iconName="person"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="alt_email"
                                        type="email"
                                        color="gray"
                                        className="font-body"
                                        label="Alternative Email Address"
                                        iconName="alternate_email"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="phone"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Contact Phone Number"
                                        iconName="call"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="address_1"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="First Line of Address"
                                        iconName="contact_mail"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="address_2"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Second Line of Address"
                                        iconName="contact_mail"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="postcode"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Postcode/Zip Code"
                                        iconName="contact_mail"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="country"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Country"
                                        iconName="contact_mail"
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="p-2 font-body  p-4 rounded-xl mt-2">
                                    <FormikInputIcon
                                        name="job_role"
                                        type="text"
                                        color="gray"
                                        className="font-body"
                                        label="Role in Organisation"
                                        iconName="badge"
                                        autoComplete="off"
                                    />
                                </div>
                            </DialogBody>
                            <DialogFooter className="dialog__footer">
                                <Button
                                    type="button"
                                    className="btn btn--secondary"
                                    variant="filled"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    disabled={!dirty || !isValid}
                                    className="btn btn--primary ml-2"
                                    variant="filled"
                                >
                                    Save
                                </Button>
                            </DialogFooter>
                        </Form>
                    )}
                </Formik>
            </>
        </Dialog>
    );
}
